import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { Button } from 'rmwc/Button';
import { Link } from 'react-router-dom'

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';

import SerializeForm from 'form-serialize'

import { Grid, GridCell } from 'rmwc/Grid';


class UserReferralDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      data: {
        page: 1,
        userReferral: []
      }
    }
  }

  componentDidMount() {
    
    let data = Object.assign({}, this.state.data)

    api.adminReferralDisplay(this.props.user.accessToken, this.state.data.page).then((result) => {
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
            data.userReferral = result.data
            this.setState({data:data})
          }
        })
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleSearch = (e) => {

    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    api.adminReferralDisplay(this.props.user.accessToken, data.page).then((result) => {
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
            data.userReferral = result.data
            this.setState({data:data})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details' })
      })
    
  }

  render() {
    let referralListComponent
    if(this.state.data.userReferral.length >0){
      referralListComponent = 
        ( <tbody>
            {this.state.data.userReferral.map(refUser => (

              <tr>
                <td>{refUser.id}</td>
                <td>{refUser.first_name}</td>
                <td>{refUser.phone}</td>
                <td>{refUser.email}</td>
                <td>{refUser.user_id}</td>
              </tr>
            ))}
          </tbody>  
        )

     }

     let paginationComponent = (

                <div>
                  <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onInputChange} value={this.state.data.page}/>
                  <Button className="add-opportunity" onClick={this.handleSearch}>
                  Fetch
              </Button>
              <br />
                </div>
              
           
        )
  
    return (

      <Grid>
          <GridCell span="12">
          <h2> User Referrals </h2>
          {paginationComponent}
          <br />
          <br />

            <div>
              <table>
                <th> S.No </th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>User ID</th>
                {referralListComponent}
              </table>
            </div>
          </GridCell>
      </Grid>
    )
  }
}

  function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
  }

  function mapDispatchToProps() {
  return {}
  }

  export default connect(mapStateToProps, mapDispatchToProps)(UserReferralDetails);





// WEBPACK FOOTER //
// ./src/views/admin/UserReferralDetails.jsx